import React, { useState, useEffect } from 'react';
import { Card, Table, Typography, Toast, Button, Space } from '@douyinfe/semi-ui';
import { useSearchParams, useNavigate } from 'react-router-dom';
const { Text } = Typography;
import request from '../../utils/request';
import styles from './index.module.scss';

const Points = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const uid = searchParams.get('uid');
    const [pointRecords, setPointRecords] = useState([]);
    const [pointPagination, setPointPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });
    const [pointLoading, setPointLoading] = useState(false);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const fetchPointRecords = async (page = 1, pageSize = 10) => {
        setPointLoading(true);
        try {
            const response = await request.get('/go/sp/su/list_user_point_record/', {
                params: {
                    page: page - 1,
                    limit: pageSize,
                    uid: uid
                }
            });
            if (response.errno === 0) {
                setPointRecords(response.list || []);
                setPointPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    total: response.total_cnt
                }));
            } else {
                Toast.error(response.errstr || '获取积分记录失败');
            }
        } catch (error) {
            console.error('获取积分记录失败:', error);
            Toast.error('获取积分记录失败');
        } finally {
            setPointLoading(false);
        }
    };

    useEffect(() => {
        fetchPointRecords();
    }, []);

    return (
        <div className={styles.pointsContainer}>
            <Card
                title="积分变更记录"
                headerStyle={{ backgroundColor: 'var(--semi-color-bg-2)' }}
                className={styles.detailCard}
            >
                <Table
                    dataSource={pointRecords}
                    loading={pointLoading}
                    pagination={{
                        currentPage: pointPagination.currentPage,
                        pageSize: pointPagination.pageSize,
                        total: pointPagination.total,
                        onPageChange: (page) => fetchPointRecords(page, pointPagination.pageSize),
                        onPageSizeChange: (size) => fetchPointRecords(1, size)
                    }}
                    columns={[
                        {
                            title: '流水ID',
                            dataIndex: 'uid',
                            width: 120
                        },
                        {
                            title: '变动积分',
                            dataIndex: 'point',
                            render: (text) => (
                                <Text type={text > 0 ? 'success' : 'danger'}>
                                    {text > 0 ? `+${text}` : text}
                                </Text>
                            )
                        },
                        {
                            title: '剩余积分',
                            dataIndex: 'point_remain'
                        },
                        {
                            title: '变动类型',
                            dataIndex: 'typ',
                            render: (text) => {
                                const typeMap = {
                                    1: { text: '消耗', type: 'danger' },
                                    2: { text: '增加', type: 'success' }
                                };
                                const type = typeMap[text] || { text: '未知', type: 'tertiary' };
                                return <Text type={type.type}>{type.text}</Text>;
                            }
                        },
                        {
                            title: '备注',
                            dataIndex: 'info',
                            render: (text) => text || '-'
                        },
                        {
                            title: '创建时间',
                            dataIndex: 'create_time',
                            render: (text) => formatTimestamp(text)
                        }
                    ]}
                />
                <Space className={styles.actionButtons} style={{ marginTop: '24px' }}>
                    <Button type="tertiary" size="large" onClick={() => navigate(-1)}>返回</Button>
                </Space>
            </Card>
        </div>
    );
};

export default Points;